import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import ServiceEntity from '../components/ServiceEntity';

class ServiceEntityPage extends Component {
  static propTypes = {
    service: PropTypes.array.isRequired
  }

  static defaultProps = {
    service: []
  }

  render() {
    const service = this.props.service;
    return (
      <ServiceEntity data={ service } />
      );
  }
}

ServiceEntityPage = connectToStores(ServiceEntityPage, ['ServiceentityStore'], (stores, props) => {
  return {
    service: stores.ServiceentityStore.get()
  };
});

export default ServiceEntityPage;


// WEBPACK FOOTER //
// ./src/pages/ServiceEntityPage.js